// NT東京2026 の号館とブース配置ブロックの対応。
//
// 会場は科学技術館 催事場 7〜11号館。ブロック文字は 11号館の A から始まり、
// 号館の番号が下がる向きに B, C, ... と続く (7号館の N まで)。
// 「I」は数字の 1 と紛れるため使わない (2025 も G, H, J の並びで飛ばしていた)。
//
// public-site (出展者一覧の号館チップ) と admin の受付端末 (配置番号の横の号館表示) の
// 両方が使うので shared に置く。会場が変わると総入れ替えになるので、画面に直書きしない。
export const VENUE_BLOCKS_2026: { hall: string; blocks: string[] }[] = [
  { hall: '11号館', blocks: ['A'] },
  { hall: '10号館', blocks: ['B', 'C', 'D'] },
  { hall: '9号館', blocks: ['E', 'F', 'G'] },
  { hall: '8号館', blocks: ['H', 'J', 'K'] },
  { hall: '7号館', blocks: ['L', 'M', 'N'] },
];

const HALL_BY_BLOCK_2026 = new Map<string, string>(
  VENUE_BLOCKS_2026.flatMap(({ hall, blocks }) => blocks.map((b) => [b, hall] as const))
);

// ブース番号の接頭辞 (A-12 の A) から号館名を引く。
export function hallOfBlock2026(block: string): string | undefined {
  return HALL_BY_BLOCK_2026.get(block);
}

// 配置番号 (A-12) から号館名を引く。
export function hallOfBooth2026(booth: string): string | undefined {
  return hallOfBlock2026(booth.split('-')[0] ?? '');
}
